module.exports = __webpack_public_path__ + "static/media/product-strategy-first.d4580f74.jpg";